<template>
  <div class="overlay" @click.self="$emit('fechar')">
    <div class="modal-filtros">
      <div class="modal-header">
        <span>Filtros Parcerias</span>
        <button class="btn-fechar" @click="$emit('fechar')">✕</button>
      </div>

      <div class="modal-corpo">
        <div class="filtro-secao">
          <p class="coluna-titulo">Local (Campus):</p>
          <select v-model="filtros.local" class="select-unidade">
            <option :value="null">Todos os campus</option>
            <option v-for="campus in campusUfc" :key="campus" :value="campus">
              {{ campus }}
            </option>
          </select>
        </div>

        <div class="datas-container">
          <div class="coluna">
            <p class="coluna-titulo">Data Inicial:</p>
            <input type="date" v-model="filtros.dataInicial" class="input-data" />
          </div>

          <div class="coluna">
            <p class="coluna-titulo">Data Final:</p>
            <input type="date" v-model="filtros.dataFinal" class="input-data" />
          </div>
        </div>
      </div>

      <div class="modal-rodape">
        <button class="btn-limpar" @click="limparFiltros">Limpar filtros</button>
        <button class="btn-filtrar" @click="aplicarFiltros">Filtrar</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  filtrosIniciais: {
    type: Object,
    default: () => ({
      dataInicial: "",
      dataFinal: "",
      local: null,
    }),
  },
});

const emit = defineEmits(["fechar", "aplicarFiltros"]);

const campusUfc = [
  "Campus do Benfica (Fortaleza)",
  "Campus do Pici (Fortaleza)",
  "Campus do Porangabuçu (Fortaleza)",
  "Campus de Crateús",
  "Campus de Itapajé",
  "Campus de Quixadá",
  "Campus de Russas",
  "Campus de Sobral"
];

const filtros = ref({
  dataInicial: props.filtrosIniciais?.dataInicial || "",
  dataFinal: props.filtrosIniciais?.dataFinal || "",
  local: props.filtrosIniciais?.local || null,
});

function limparFiltros() {
  filtros.value = { dataInicial: "", dataFinal: "", local: null };
  emit("aplicarFiltros", { ...filtros.value });
  emit("fechar");
}

function aplicarFiltros() {
  emit("aplicarFiltros", { ...filtros.value });
  emit("fechar");
}
</script>

<style scoped>
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-filtros {
  background: var(--branco);
  border-radius: 12px;
  width: auto;
  min-width: 580px;
  max-width: 95vw;
  overflow: hidden;
  box-shadow: 0 8px 32px var(--preto);
}

.modal-header {
  background: var(--roxo-escuro2);
  color: var(--branco);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 20px;
  font-size: 1rem;
  font-weight: 600;
  position: relative;
}

.btn-fechar {
  position: absolute;
  right: 14px;
  background: transparent;
  border: 2px solid var(--branco);
  color: var(--branco);
  border-radius: 6px;
  width: 28px;
  height: 28px;
  cursor: pointer;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-corpo {
  display: flex;
  flex-direction: column;
  padding: 30px 20px;
  background: var(--branco);
  gap: 24px;
}

.datas-container {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.filtro-secao {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.coluna {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
}

.coluna-titulo {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--preto);
  margin: 0;
}

.input-data,
.select-unidade {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 0.9rem;
  outline: none;
  width: 100%;
  background: white;
}

.select-unidade {
  padding-right: 32px;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23563578' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.input-data:focus,
.select-unidade:focus {
  border-color: var(--roxo-claro);
}

.modal-rodape {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding: 20px;
  background: var(--branco);
}

.btn-limpar {
  border: 2px solid var(--roxo-claro);
  background: var(--branco);
  color: var(--roxo-claro);
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}

.btn-filtrar {
  background: var(--roxo-claro);
  color: var(--branco);
  border: none;
  border-radius: 10px;
  padding: 8px 28px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
}
</style>